module.exports = __webpack_public_path__ + "static/Hero-img-7220eae040d5e9e52f6a6933954f86ec.jpg";